var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<span ng-if=\"vm.parameter[vm.key].wert\">Ja</span><span ng-if=\"!vm.parameter[vm.key].wert\">Nein</span>");;return buf.join("");
}